import { TransferStateEnum } from "@payping/api";

export enum DepositStatementEnum {
  ALL,
  DEBIT,
  CREDIT,
  PayPingWage,
}

export interface ListQueryParamsType {
  turnOverType?: DepositStatementEnum;
  description?: string;
  pageNumber?: number;
  pageSize?: number;
  startDate?: string;
  endDate?: string;
  referenceNumber?: string;
  state?: TransferStateEnum;
}
export type ListStringQueryParamsType = Pick<
  ListQueryParamsType,
  "startDate" | "endDate" | "description" | "referenceNumber"
>;
export type ListNumberQueryParamsType = Pick<ListQueryParamsType, "pageNumber" | "pageSize" | "turnOverType" | "state">;
